<template>
  <div class="wrapper">
      <Navbar :nav="entry.nav"/>
      <Content/>
  </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import Navbar from './components/Navbar.vue';
import Content from './components/Content.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Content,
    Content
},
  computed: {
    ...mapState(['entry']),
  },
  methods: {
    ...mapActions(['getMenu']),
  },
  created() {
    this.getMenu();
  }
}
</script>

<style>
@import './assets/style.css';
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
